module.exports = __webpack_public_path__ + "img/springtime-shrimp-flatbread.28116047.jpg";